export const RIGHT_TOOLBAR_CONFIG_TYPES = {
  RIGHT_TOOLBAR_ENABLED: 'RIGHT_TOOLBAR_ENABLED',
  RIGHT_TOOLBAR_DISABLED: 'RIGHT_TOOLBAR_DISABLED'
};
export const rightToolbarDisabled = {
  type: RIGHT_TOOLBAR_CONFIG_TYPES.RIGHT_TOOLBAR_DISABLED
};
export function isRightToolbarEnabled(config) {
  return config.type === RIGHT_TOOLBAR_CONFIG_TYPES.RIGHT_TOOLBAR_ENABLED;
}